import React, { useEffect, useState } from 'react';
import '../CSS/FAQ.css';

const FAQ = () => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    document.title = 'Frequently Asked Questions | MuscleCrete';
    document.querySelector('meta[name="description"]').setAttribute(
      'content',
      'Find answers to common questions about MuscleCrete products, installation, shipping, and support.'
    );
  }, []);

  const faqData = [
    {
      category: 'Product Questions',
      items: [
        {
          id: 1,
          question: 'What is MuscleCrete?',
          answer: 'MuscleCrete is a premium brand of concrete coatings, tile adhesives, and grouts manufactured by PAC Corporation. Our products are ISO 9001-2015 certified and CE certified for superior quality and durability.'
        },
        {
          id: 2,
          question: 'What are the different product types?',
          answer: 'We offer a comprehensive range including concrete coatings for protection and aesthetics, tile adhesives for strong bonding, and grouts for joint filling. Each product is engineered for specific applications and environments.'
        },
        {
          id: 3,
          question: 'Are MuscleCrete products eco-friendly?',
          answer: 'Yes, we use eco-friendly formulations that minimize environmental impact while maintaining superior performance and durability standards.'
        },
        {
          id: 4,
          question: 'What is the shelf life of MuscleCrete products?',
          answer: 'Most MuscleCrete products have a shelf life of 12-24 months when stored in cool, dry conditions. Check the product packaging for specific details.'
        }
      ]
    },
    {
      category: 'Installation & Application',
      items: [
        {
          id: 5,
          question: 'Can I apply MuscleCrete products myself?',
          answer: 'Yes, most MuscleCrete products are designed for both professional and DIY application. However, we recommend following the application guidelines on the product package or consulting our technical team for best results.'
        },
        {
          id: 6,
          question: 'What surface preparation is needed?',
          answer: 'Proper surface preparation is crucial. Surfaces should be clean, dry, and free from dust, oil, and loose material. Detailed preparation instructions are provided with each product.'
        },
        {
          id: 7,
          question: 'How long does application take?',
          answer: 'Application time varies by product type and surface area. Typically, coating application takes 2-4 hours for standard residential areas. Curing time varies from 24-72 hours depending on the product.'
        },
        {
          id: 8,
          question: 'What temperature range is suitable for application?',
          answer: 'Most MuscleCrete products perform best when applied between 15°C and 35°C. Avoid application in extreme temperatures or high humidity conditions.'
        }
      ]
    },
    {
      category: 'Shipping & Delivery',
      items: [
        {
          id: 9,
          question: 'How are MuscleCrete products shipped?',
          answer: 'We ship products through reliable courier services ensuring safe delivery. Products are well-packaged to prevent damage during transit.'
        },
        {
          id: 10,
          question: 'What are the delivery times?',
          answer: 'Standard delivery typically takes 3-5 business days within India. Express delivery options are available for urgent orders.'
        },
        {
          id: 11,
          question: 'Do you offer free shipping?',
          answer: 'Free shipping is available on orders above a certain value. Check our website for current shipping offers and eligibility criteria.'
        },
        {
          id: 12,
          question: 'Can I track my order?',
          answer: 'Yes, all orders include tracking information. You\'ll receive a tracking number via email that allows you to monitor your delivery in real-time.'
        }
      ]
    },
    {
      category: 'Support & Warranty',
      items: [
        {
          id: 13,
          question: 'Do MuscleCrete products have a warranty?',
          answer: 'Yes, our products come with a quality guarantee. Warranty details vary by product type and are provided with purchase documentation.'
        },
        {
          id: 14,
          question: 'How do I get technical support?',
          answer: 'Our expert technical team is available 24/7 through email, phone, and live chat to answer product and application questions.'
        },
        {
          id: 15,
          question: 'What if I receive a damaged product?',
          answer: 'If you receive damaged products, please contact us immediately with photos. We will arrange for a replacement or refund as per our customer care policy.'
        },
        {
          id: 16,
          question: 'Can you provide installation guidance?',
          answer: 'Absolutely! We provide detailed installation guides, video tutorials, and can arrange for professional installation consultation when needed.'
        }
      ]
    }
  ];

  const toggleItem = (itemId) => {
    setActiveItem(activeItem === itemId ? null : itemId);
  };

  return (
    <main className="faq-page">
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="container">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about MuscleCrete products and services</p>
        </div>
      </section>

      {/* FAQ Sections */}
      <section className="faq-content">
        <div className="container">
          {faqData.map((category, categoryIdx) => (
            <div key={categoryIdx} className="faq-category">
              <h2 className="category-title">{category.category}</h2>
              <div className="accordion">
                {category.items.map(item => (
                  <div key={item.id} className="accordion-item">
                    <button
                      className={`accordion-header ${activeItem === item.id ? 'active' : ''}`}
                      onClick={() => toggleItem(item.id)}
                      aria-expanded={activeItem === item.id}
                    >
                      <span className="accordion-icon">
                        {activeItem === item.id ? '−' : '+'}
                      </span>
                      <span className="accordion-question">{item.question}</span>
                    </button>
                    <div
                      className={`accordion-content ${activeItem === item.id ? 'active' : ''}`}
                      style={{
                        maxHeight: activeItem === item.id ? '500px' : '0'
                      }}
                    >
                      <p>{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact CTA */}
      <section className="faq-contact">
        <div className="container">
          <h2>Didn't find your answer?</h2>
          <p>Our support team is ready to help you with any questions or concerns.</p>
          <a href="/contact" className="contact-button">Contact Us</a>
        </div>
      </section>
    </main>
  );
};

export default FAQ;
